import React from "react";
import "./index.css";
import { FaDiscord } from "react-icons/fa";
import { FiDownload } from "react-icons/fi";
import Snowfall from "react-snowfall";

export default function App() {
  const apps = [
    {
      name: "CapCut",
      version: "5.7.0",
      date: "14.01.2025",
      img: "https://www.pngmart.com/files/23/Capcut-Logo-PNG-Photos.png",
      download: "https://github.com/revolt-empt/Software/releases/download/EMP3/CapCut-EMPTERROR.rar",
    },
    {
      name: "WinRAR",
      version: "Universal",
      date: "12.04.2026",
      img: "https://static.wikia.nocookie.net/logopedia/images/4/4f/WinRAR_Logo_2018.png",
      download: "https://github.com/revolt-empt/Software/releases/download/EMPTERROR/WinRAR-EMPTERROR.rar",
    },
    {
      name: "PPSSPP GOLD",
      version: "1.19.3",
      date: "01.10.2025",
      img: "https://i.ibb.co/v4mp0Sqy/images-removebg-preview.png",
      download: "https://github.com/revolt-empt/Software/releases/download/EMP2/PPSSPP-EMPTERROR.rar",
    },
    {
      name: "HitmanPro",
      version: "3.8.44",
      date: "04.11.2025",
      img: "https://malwaretips.com/blogs/wp-content/uploads/2022/10/HitmanPro-logo.png",
      download: "https://github.com/revolt-empt/Software/releases/download/EMPT-hitmanpro/HitmanPro-EMPTERROR.rar",
    },
    {
      name: "Spotify",
      version: "1.2.10",
      date: "29.09.2025",
      img: "https://m.media-amazon.com/images/I/51rttY7a+9L._h1_.png",
      download: "https://github.com/revolt-empt/Software/releases/download/empt4/Spotify-EMPTERROR.rar",
    },
    {
      name: "Driver Booster",
      version: "13",
      date: "29.09.2025",
      img: "https://www.kaldata.com/wp-content/uploads/2016/07/Iobit-Driver-Booster.png",
      download: "https://github.com/revolt-empt/Software/releases/download/empt5/Driver.Booster-EMPTERROR.rar",
    },
    {
      name: "Lossless Scaling",
      version: "3.2.1",
      date: "29.09.2025",
      img: "https://cdn2.steamgriddb.com/icon_thumb/b59afec3c8a23ac3fe9ad100261fa291.png",
      download: "https://github.com/revolt-empt/Software/releases/download/empt7/Lossless.Scaling-EMPTERROR.rar",
    },
    {
      name: "IDM",
      version: "Universal",
      date: "27.04.2026",
      img: "https://img.utdstc.com/icon/2b6/7d8/2b67d8d47efc520e4f344d41cf59eb0344846f0c93fd5cf2b7d0d4914e22dd2d:200",
      download: "https://github.com/revolt-empt/Software/releases/download/empt12/IDM-EMPTERROR.rar", 
    },
    {
      name: "Wand (WeMod)",
      version: "12.0.3",
      date: "02.12.2025",
      img: "https://www.wemod.com/static/images/wemod-logo-1024-dafdcb2c3b.png",
      download: "https://github.com/revolt-empt/Software/releases/download/empt10/Wand.WeMod.-EMPTERROR.rar",
    },
    {
      name: "NTLite",
      version: "10631",
      date: "11.10.2025",
      img: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e0/NLite_Logo.svg/330px-NLite_Logo.svg.png",
      download: "https://github.com/revolt-empt/Software/releases/download/empt11/NTLite-EMPTERROR.rar",
    },
    {
      name: "IDA Pro",
      version: "9.3",
      date: "12.04.2026",
      img: "https://static.wikitide.net/zenithwiki/0/0d/IDAIcon.png",
      download: "https://github.com/revolt-empt/Software/releases/download/Revolt8/IDA.PRO.9.3-EMPTERROR.rar",
    },
    {
      name: "Revo Uninstaller",
      version: "Universal",
      date: "19.04.2026",
      img: "https://upload.wikimedia.org/wikipedia/commons/8/83/Revouninstallerpro_icon.png",
      download: "https://github.com/revolt-empt/Software/releases/download/EMPT9/Revo.Uninstaller.Pro-EMPTERROR.rar",
    },
    {
      name: "FL Studio",
      version: "25.1.6",
      date: "24.10.2025",
      img: "https://icons.iconarchive.com/icons/ncrow/mega-pack-1/256/Fruity-Loops-Studio-icon.png",
      download: "https://github.com/revolt-empt/Software/releases/download/empt13/FL.Studio-EMPTERROR.rar",
    },
    {
      name: "Kaspersky",
      version: "21.25.4",
      date: "27.03.2026",
      img: "https://upload.wikimedia.org/wikipedia/commons/4/4e/Kaspersky_icon.svg",
      download: "https://github.com/revolt-empt/Software/releases/download/empt14/Kaspersky-EMPTERROR.rar",
    },
    {
      name: "CCleaner",
      version: "7.01.1066",
      date: "02.01.2026",
      img: "https://upload.wikimedia.org/wikipedia/en/4/4a/CCleaner_logo_2013.png",
      download: "https://github.com/revolt-empt/Software/releases/download/empt16/CCleaner-EMPTERROR.rar",
    },
    {
      name: "Binary Ninja",
      version: "5.2.8722",
      date: "03.01.2026",
      img: "https://binary.ninja/icons/android-chrome-512x512.png",
      download: "https://github.com/revolt-empt/Software/releases/download/empt17/BinaryNinja-EMPTERROR.rar",
    },
    {
      name: "DaVinci Resolve",
      version: "20.3.1",
      date: "13.01.2026",
      img: "https://upload.wikimedia.org/wikipedia/commons/4/4d/DaVinci_Resolve_Studio.png",
      download: "https://vikingfile.com/f/AWP0g0tHJe#DaVinci.Resolve",
    },
    {
      name: "3ds Max",
      version: "2026",
      date: "14.01.2026",
      img: "https://www.shareicon.net/data/2015/09/24/106333_3ds_512x512.png",
      download: "https://github.com/revolt-empt/Software/releases/download/empt18/Autodesk.3ds.Max-EMPTERROR.rar",
    },
    {
      name: "HeavyM Pro",
      version: "2.14.5",
      date: "17.01.2026",
      img: "https://www.heavym.net/wp-content/uploads/2020/09/Logo-Verticale-Base-Sans-signature-Small-border.svg",
      download: "https://github.com/revolt-empt/Software/releases/download/empt19/HeavyMPro-EMPTERROR.rar",
    },
    {
      name: "Advanced SystemCare",
      version: "19.3.0.200",
      date: "04.04.2026",
      img: "https://img.utdstc.com/icon/2ae/723/2ae72380b9e9194a16c011ca83423b393143c065ceb4aac6d7020254f30eaa12:200",
      download: "https://github.com/revolt-empt/Software/releases/download/empt20/Advanced.SystemCare.Pro-EMPTERROR.rar",
    },
    {
      name: "Malwarebytes",
      version: "Universal",
      date: "19.04.2026",
      img: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/27/Malwarebytes_Logo_%282016%29.svg/1280px-Malwarebytes_Logo_%282016%29.svg.png",
      download: "https://github.com/revolt-empt/Software/releases/download/empt21/Malwarebytes-EMPTERROR.rar",
    },
    {
      name: "ESET",
      version: "Universal",
      date: "19.04.2026",
      img: "https://media.invisioncic.com/Meset/post-3952-0-29464900-1413646878.png",
      download: "https://github.com/revolt-empt/Software/releases/download/empt22/ESET-EMPTERROR.rar",
    },
    {
      name: "3DMark",
      version: "Universal",
      date: "10.05.2026",
      img: "https://cdn2.steamgriddb.com/icon_thumb/deb74a85a4a68465b75c721d45db5d3b.png",
      download: "https://github.com/revolt-empt/Software/releases/download/empt23/3DMark-EMPTERROR.rar",
},
  ];

  const downloadFile = (url) => {
    const link = document.createElement("a");
    link.href = url;
    link.download = "";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="app-container">
      <Snowfall
        snowflakeCount={150}
        radius={[1, 2]}
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          zIndex: -1,
        }}
        speed={[0.5, 2]}
        wind={[-0.5, 0.5]}
      />

      <header>
        <h1>REVOLT</h1>
        <a
          href="https://discord.gg/rCV96QsvBF"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaDiscord size={50} />
        </a>
      </header>

      <main>
        {apps.map((app, index) => (
          <div className="main-box" key={index}>
            <img src={app.img} alt={app.name} className="box-image" />
            <div className="box-text">
              <p className={app.name === "CapCut" ? "app-name white" : "app-name"}>
                {app.name}
              </p>
              <p className="version">Version: {app.version}</p>
              <p className="date">{app.date}</p>
            </div>
            <FiDownload
              className="download-icon"
              size={28}
              onClick={() => downloadFile(app.download)}
            />
          </div>
        ))}
      </main>
    </div>
  );
}
